import _get from 'lodash/get';
import * as actions from '../actions/constants';

const initialState = {
  isDashboardLoading: false,
  isSRLDashboardLoading: false,
  SRLWidgetsHeight: 426,
  widgetDetailModalVisible: 0,
  selectedAssignment: {},
  dashboard: {
    widgets: [],
    assignments: [],
  },
  surveys: {
    srlSurveyList: [],
    srlSurveyResults: {},
    srlSurveyResultsByCardData: {},
  },
};

function insights(state = initialState, action) {
  switch (action.type) {
    case actions.GET_DASHBOARD_REQUEST: {
      return {
        ...state,
        isDashboardLoading: true,
      };
    }
    case actions.GET_DASHBOARD_RESPONSE: {
      return {
        ...state,
        dashboard: {
          ...action.payload.dashboard,
          assignments: action.payload.assignments,
          widgets: _get(action.payload, 'dashboard.widgets', []).map((w) => ({
            ...w,
            isLoading: true,
          })),
        },
        isDashboardLoading: false,
      };
    }
    case actions.GET_SRL_REQUEST:
    case actions.GET_SRL_RESULTS_REQUEST:
    case actions.GET_SRL_RESULT_CARD_REQUEST: {
      return {
        ...state,
        isSRLDashboardLoading: true,
      };
    }
    case actions.GET_SRL_RESPONSE: {
      return {
        ...state,
        surveys: {
          ...state.surveys,
          srlSurveyList: action.payload.srlSurveyList,
        },
        isSRLDashboardLoading: false,
      };
    }
    case actions.GET_SRL_RESULTS_RESPONSE: {
      const surveyState = state.surveys;
      const assignmentId = action.payload.assignmentId;
      // Give survey card data the minimum data it needs to work in dashboards ui
      const formattedResults = action.payload.srlSurveyResults.map(
        (result, index) => ({
          ...result,
          isSRLWidget: true,
          widgetType: result.card_name,
          srlCardId: result.card_id,
          assignmentIds: [assignmentId],
          coordinates: {
            x: index % 2,
            y: Math.floor(index / 2),
            w: 1,
            h: 1,
          },
        })
      );
      state.surveys.srlSurveyResults[
        action.payload.assignmentId
      ] = formattedResults;
      return {
        ...state,
        surveys: {
          ...surveyState,
        },
      };
    }
    case actions.GET_SRL_RESULT_CARD_RESPONSE: {
      const surveyState = state.surveys;
      surveyState.srlSurveyResultsByCardData[
        `${action.payload.assignmentId}-${action.payload.cardId}`
      ] = action.payload.srlSurveyResultsByCardData;
      return {
        ...state,
        surveys: {
          ...surveyState,
        },
      };
    }
    case actions.DELETE_DASHBOARD_WIDGET: {
      const dashboardWidgetId = action.payload.dashboardWidgetId;
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          widgets: state.dashboard.widgets.filter(
            (w) => w.dashboardWidgetId !== dashboardWidgetId
          ),
        },
      };
    }
    case actions.ADD_WIDGET_TO_DASHBOARD: {
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          widgets: [...state.dashboard.widgets, action.payload.widget],
        },
      };
    }
    case actions.UPDATE_WIDGETS: {
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          widgets: state.dashboard.widgets.map((widget) => {
            const updatedWidget = action.payload.find(
              (uW) => widget.dashboardWidgetId === uW.dashboardWidgetId
            );
            if (updatedWidget) {
              return {
                ...widget,
                ...updatedWidget,
              };
            }
            return widget;
          }),
        },
      };
    }
    case actions.TOGGLE_WIDGET_DETAIL_MODAL: {
      return {
        ...state,
        widgetDetailModalVisible:
          action.payload.widgetDetailModalVisible > 0
            ? 0
            : action.payload.widgetId,
      };
    }
    case actions.CLEAR_INSIGHT_MODALS: {
      return {
        ...state,
        widgetDetailModalVisible: 0,
      };
    }
    case actions.CONTAINER_WIDTH_CHANGE: {
      return {
        ...state,
        containerWidth: action.payload,
      };
    }
    case actions.GET_ASSIGNMENTS: {
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          assignments: action.payload,
        },
      };
    }
    case actions.SET_INSIGHTS_SELECTED_ASSIGNMENT: {
      return {
        ...state,
        selectedAssignment: action.payload,
      };
    }
    case actions.APP_LOGOUT:
    case actions.CLEAR_REPORTS: {
      return initialState;
    }
    case actions.UPDATE_SRL_WIDGETS_HEIGHT: {
      return {
        ...state,
        SRLWidgetsHeight: action.payload,
      };
    }
    default:
      return state;
  }
}

insights.constants = {
  initialState,
};

export default insights;
